import React from 'react';
import { CreateExam } from './CreateExam';
import { DeleteExam } from './DeleteExam';
import { UpdateExam } from './UpdateExam';
import { Dialog } from 'primereact/dialog';

export const ModalExam = (props) => {

    const {

        formValues,
        method, handleInputChange, validaciones, validationSectionArea,
        sections, specimenOrigins, subSections, commercialLines, specimens, specimenProvenances, typeTransports, transports,
        id_section, id_subsection, id_specimen_origin, code, alias, name, abbreviation, individual_sale, cost, is_referenced, is_critic, print_new_page,
        closeDialog, modal, modalTitle, loading, listExternalLaboratories, examId, getUpdateDefaultExternalLaboratory,
        changeSelect, handleSelectValues,
        saveCreate,
        saveUpdate,
        saveDelete,
        handleChangePrice,isImagenologyy,
           //*CONFIGURATION EXTERNAL LABORATORY
           dataLaboratory,handleChangePriceIni,
           //* CURVES
           is_curve, showCurveField, loadingSaveExam
    } = props;


    return (
        
        <Dialog
            visible={modal}  
            onHide={closeDialog}
            header={modalTitle}         
            modal
            closable
            dismissableMask={false} 
            blockScroll  
            className={method === "delete" ? "tiny-dialog" : "large-dialog-exam"}
            position="top"
            style={{ marginTop: 20 }}
        >
            {
                method === "create"
                    ? <CreateExam {...{ formValues, closeDialog, handleInputChange, handleChangePrice, handleSelectValues, validaciones, loading, sections, changeSelect, specimenOrigins, subSections, commercialLines, specimens, specimenProvenances, typeTransports, transports, id_section, id_subsection, id_specimen_origin, code, alias, name, abbreviation, individual_sale, cost, is_referenced, methodAction: saveCreate ,isImagenologyy, print_new_page, validationSectionArea,loadingSaveExam, 
                        //*CONFIGURATION EXTERNAL LABORATORY
                    dataLaboratory,handleChangePriceIni, showCurveField }} />
                    : (method === "update")
                        ? <UpdateExam {...{ formValues, closeDialog, handleInputChange, validaciones, 
                            loading, sections, handleSelectValues, changeSelect, specimenOrigins, subSections, 
                            commercialLines, specimens, specimenProvenances, transports, id_section, id_subsection,
                            id_specimen_origin, code, alias, name, abbreviation, individual_sale, is_referenced, is_critic, 
                            listExternalLaboratories, examId, getUpdateDefaultExternalLaboratory, methodAction: saveUpdate,
                             print_new_page, validationSectionArea,     //*CONFIGURATION EXTERNAL LABORATORY
                             dataLaboratory,handleChangePriceIni, showCurveField, is_curve, loadingSaveExam
                                
                            
                            }  
                            }         />
                        : null
            }


        </Dialog>
       
    )
}
